export default __webpack_public_path__ + "locales/vi/PDFFormDialog.json?hash=8b005786eda4a610b253cc4012ea37a7";